export default "__VITE_ASSET__CAoyxLjW__"